import * as React from "react";

import { cn } from "../../lib/cn";

function Textarea({ className, id: idProp, ...props }: React.ComponentProps<"textarea">) {
  const generatedId = React.useId();
  const id = idProp ?? generatedId;
  return (
    <textarea
      id={id}
      data-slot="textarea"
      className={cn(
        "border-input placeholder:text-[--placeholder-foreground] focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 flex field-sizing-content min-h-16 w-full rounded-md border bg-transparent px-3 py-2 text-sm shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 max-md:text-base!",
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
